/**
 * Remove non-unique values from array via the provided predicate
 * @function uniqueBy
 * @param {V[]} arr array
 * @param {(b: V) => keyof V} predicate function targeting unique property
 * @returns {V[]} array containing unique values
 */
export const uniqueBy = <K extends string | number | symbol, V>(
	arr: V[],
	predicate: (value: V, index: number, arr: V[]) => K
): V[] =>
	Object.values(
		arr.reduce(
			(obj, value, index) => {
				const key = predicate(value, index, arr);

				obj[key] = value;

				return obj;
			},
			{} as Record<K, V>
		)
	);
